import React from 'react';

interface IProps {
  message?: string;
}

const AuthError: React.FC<IProps> = ({ message = 'Missing required authentication' }) => {
  return (
    <div>
      <div className={'flex h-screen w-screen flex-col items-center justify-center'}>
        <h1 className={'text-foreground text-xl font-black'}>401 Authentication</h1>
        <h3 className={'font-500 text-foreground text-lg'}>{message}</h3>
      </div>
    </div>
  );
};

export default AuthError;
